import styled from "@emotion/styled"
import { Button, Link } from "@mui/material"
import { colors, mediaQueries, sizes } from "ui"
import { getNonUmbracoUrl } from "utils"

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  ${mediaQueries.desktopXl} {
    width: 216px;
  }
`
const StyledButton = styled(Button)`
  width: 100%;
  padding-top: 9.5px;
  padding-bottom: 9.5px;
  font-size: 16px;
  color: ${colors.black};
  font-weight: 400;
  ${mediaQueries.desktopM} {
    font-size: 14px;
  }
  ${mediaQueries.desktopXl} {
    font-size: 14px;
    padding-inline-start: ${sizes.baseHalf};
    padding-inline-end: ${sizes.baseHalf};
    height: 100%;
  }
`

interface ActionItemProps {
  item: any
  onClick?: (buttonText: string) => void
}
const ActionItem = ({ item, onClick }: ActionItemProps) => {
  const { link, title } = item
  return (
    <StyledLink
      target={link?.type?.toLowerCase() === "external" ? "_blank" : "_self"}
      href={getNonUmbracoUrl(link?.url)}
      onClick={() => onClick?.(item?.name || item?.itemName)}
    >
      <StyledButton variant="outlined">{title}</StyledButton>
    </StyledLink>
  )
}

export default ActionItem
